// src/components/VideoSection.js
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaPlay, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

const VideoSection = () => {
  const [open, setOpen] = useState(false);

  const thumbnail =
    "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772627036/9a50bf64-e02e-4ba0-8d12-6730a00c6978_ibesxo.jpg";

  const videoUrl =
    "https://res.cloudinary.com/dgwnm39m7/video/upload/v1780770308/IMG_2941_ntuhto.mov";

  return (
    <>
      {/* SECTION */}
      <section
      id="videosection"
        className="relative h-[400px] 2xl:h-[450px] backgroundattachment bg-cover flex items-center justify-center text-center text-white"
        style={{ backgroundImage: `url(${thumbnail})`,backgroundPosition:"50% 50%" }}
        
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* Content */}
        <div className="relative z-10 px-6 max-w-4xl space-y-4">
          {/* Play Button */}
          <div
            onClick={() => setOpen(true)}
            className="w-20 h-20 mx-auto rounded-full  backdrop-blur-md flex items-center justify-center cursor-pointer hover:scale-110 bg-[#c9a86c] text-white px-6 py-4 font-medium hover:bg-[#b38f5a] transition text-md"
          >
            <FaPlay className="text-white text-2xl ml-1" />
          </div>

          <h2  className="text-4xl lg:text-5xl font-light  leading-tight">
            Enjoy And Watch <span className="font-bold text-[#c9a86c]">Hotelux Experience</span>
          </h2>

          <button className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group">
           <Link to="/contact" className="text-white">Book Now</Link>
          </button>
        </div>
      </section>

      {/* VIDEO MODAL */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/90 flex items-center justify-center z-50"
          >
            {/* Close Button */}
            <button
              onClick={() => setOpen(false)}
              className="absolute top-6 right-6 text-white text-2xl"
            >
              <FaTimes />
            </button>

            <motion.video
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.4 }}
              src={videoUrl}
              controls
              autoPlay
              className=" rounded-lg max-w-7xl h-[700px] shadow-lg"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default VideoSection;